<template>
  <div class="common-layout h-100" @mousemove="resetTimer" @keydown="resetTimer">
    <router-view />
    <div v-if="isLoading" id="popup-overlay">
      <bounce-loader :loading="isLoading" :color="color" :size="size"/>
    </div>
  </div>
</template>

<script lang="js">
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
import { mapState } from 'vuex'
import Mixin from './mixins/global.mixin'
import $ from 'jquery'
import appConstants from './constants/app.constants'
import store from './store'

export default {
  name: 'App',
  mixins: [Mixin],
  components: {
    BounceLoader: BounceLoader
  },
  watch:{
    $route: function () {
      //console.log(this.$route);
      this.toggleFullScreenSpinner(true);
      if (this.isMobile()) {
        store.commit('SET_SIDEBAR_TOGGLE', true);
      }
      $('#chartdiv').empty();
    },
  },
  computed: mapState([
    'isLoading',
    'jwtToken',
    'currentUserSession',
    'currentSessionRailsID'
  ]),
  setup() {
    return {
      appConstants: appConstants
    }
  },
  data() {
    return {
      color: '#51E1E5',
      size: '80px',
    }
  },
  methods: {
    detectPageReload: function () {
      const navType = window.performance.navigation.type;
      if (navType === 1) {
        //store.commit('SET_ORDER_LIST_STORAGE', []);
        store.commit('SET_CURRENT_ORDER_DETAILS', null);
        store.commit('SET_CURRENT_SHIPSTATION_DETAILS', null);
      }
    },
  },
  mounted() {
    this.getFedexToken();
    this.detectPageReload();
    // Get the current URL
    const queryString = window.location.search;
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams(queryString);
    // Get the value of the 'login_type' parameter

    //this.checkLoginType(urlParams);
    store.commit('SET_ORIGIN', urlParams.get('method') ? urlParams.get('method') : 'Portal');
	
    // display chatbase chatbox
    // window.chatbaseConfig = {
    //   chatbotId: "SK8-MnMlYkc6RiBaoLo2t",
    // }
    
  }
}
</script>